import { useContext } from 'react';
import { Checkbox, Typography, Box } from '@mui/material';
import ShoppingListContext from '../../context/shopping-list-context';

const ShoppingListView = () => {
  const { entries, toggleEntry } = useContext(ShoppingListContext);

  if (entries.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
        Nákupní seznam je prázdný
      </Typography>
    );
  }

  const handleToggle = async (entryId: string, currentChecked: boolean) => {
    await toggleEntry(entryId, !currentChecked);
  };

  return (
    <Box>
      {entries.map((entry) => (
        <Box
          key={entry.id}
          onClick={() => handleToggle(entry.id, entry.checked)}
          sx={{ display: 'flex', alignItems: 'flex-start', py: 0.5, cursor: 'pointer' }}
        >
          <Checkbox
            checked={entry.checked}
            size="small"
            sx={{ p: 0.5, mr: 1, mt: '1px' }}
            tabIndex={-1}
            disableRipple
          />
          <Box sx={{ opacity: entry.checked ? 0.4 : 1 }}>
            <Typography
              variant="body2"
              sx={{ textDecoration: entry.checked ? 'line-through' : 'none', fontWeight: 500 }}
            >
              {entry.displayName}
            </Typography>
            {entry.sources.length > 0 && (
              <Typography variant="caption" color="text.secondary">
                {entry.sources.map((s) => `${s.quantity} (${s.mealName})`).join(', ')}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ShoppingListView;
